import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { customAlphabet } from 'nanoid';
import { Observable } from 'rxjs';
import { generateTraceIdSegment } from '../utils/trace-id-segment';

@Injectable()
export class ContentTypeInterceptorService implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url === ApiEndpoint.USER_LOGIN || request.url === ApiEndpoint.USER_OAUTH_LOGIN_VIA_HASH) {
      return next.handle(request);
    }

    const traceIdSegment = generateTraceIdSegment();
    const spanIdSegment = customAlphabet('1234567890abcdef', 16)();

    const requestWithContentType = request.clone({
      setHeaders: {
        'Content-type': 'application/json',
        'X-TEN-Trace-Id': `${traceIdSegment}-TPFE`,
        'traceparent': `00-${traceIdSegment}-${spanIdSegment}-01`,
      },
    });

    return next.handle(requestWithContentType);
  }
}
